/**
 * Programmes Singular page
 * @author Alexandre Flatres
 * modifié par artwaï pour artwaï
 */
 
 (function () {
 
    function ready() {
        var bottomHero = document.getElementsByClassName('hero')[0].offsetHeight;
        var body = document.getElementsByTagName('body');
    
        function scroll(event) {
            var y = document['documentElement' || 'body'].scrollTop;
            
            if (y >= bottomHero) {
                body[0].classList.add('sticky');
            } else {
                body[0].classList.remove('sticky');
            }
        }
        if (window.matchMedia("(min-width: 960px)").matches) {
            /* DESKTOP + WIDE */
            window.addEventListener('scroll', scroll);
        }
    }
    
    if (document.readyState == 'complete' || document.readyState == 'loaded') {
        ready();
    } else {
        window.addEventListener('DOMContentLoaded', ready);
    } 
     
 }());